import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { fetchConfig, type ConfigResponse } from "../services/config";

// 配置状态
export interface ConfigState {
  // 后台配置数据
  data: ConfigResponse | null;
  // 是否正在加载
  isLoading: boolean;
  // 错误信息
  error: string | null;
}

// 初始状态
const initialState: ConfigState = {
  data: null,
  isLoading: false,
  error: null,
};

// 异步获取配置
export const loadConfig = createAsyncThunk(
  "config/loadConfig",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchConfig();
      return response;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "获取配置失败"
      );
    }
  }
);

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    // 设置配置数据
    setConfig: (state, action: PayloadAction<ConfigResponse>) => {
      state.data = action.payload;
    },
    // 清除配置数据
    clearConfig: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadConfig.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loadConfig.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(loadConfig.rejected, (state, action) => {
        state.isLoading = false;
        state.error = (action.payload as string) || "获取配置失败";
      });
  },
});

// 导出 actions
export const { setConfig, clearConfig } = configSlice.actions;

// 导出 reducer
export default configSlice.reducer;
